export default __webpack_public_path__ + "static/media/dealermgr-hover.6c3859bf.svg";